﻿function configureXsrfToken(xsrfToken: string) {
    $.ajaxPrefilter(function (options) {
        if (!options.beforeSend) {
            options.beforeSend = function (xhr) {
                xhr.setRequestHeader("X-XSRF-TOKEN", xsrfToken);
            }
        }
    });
}

window.configureXsrfToken = configureXsrfToken

$(function () {
    // Initialize tooltips with delegation for dynamic content
    $(document.body).tooltip({
        selector: "[data-toggle='tooltip']",
        container: 'body', // Append to body to avoid overflow clipping
        trigger: 'hover focus' // Default triggers
    });
});

// Show the "new" label if the current date is before the date specified in the data-new-until attribute
// This code will show the "new" label if the current date is before the date specified in the data-new-until attribute
document.addEventListener("DOMContentLoaded", () => {
    const now = new Date();

    document.querySelectorAll('.label.label-success[data-new-until]')
        .forEach(el => {
            const text = el.textContent?.trim().toLowerCase();
            const dateAttr = el.getAttribute('data-new-until');

            if (text === 'new' && dateAttr) {
                const [year, month, day] = dateAttr.split('-').map(Number);
                const expiry = new Date(year, month - 1, day + 1); // Include full last day

                if (now <= expiry) {
                    (el as HTMLElement).style.display = 'inline';
                }
            }
        });
});

